import * as React from 'react';
import {StyleSheet, TextStyle, View, ViewStyle} from 'react-native';
import SoundView from './SoundView';

import Sound from '../../../../../../../domain/entities/Sound';

interface Props {
  sound: Sound;
  children?: React.ReactNode;
}

const SoundEffectView: React.FunctionComponent<Props> = props => {
  const {sound} = props;
  return (
    <View style={styles.container}>
      <SoundView sound={sound} iconSize={32} labelStyle={styles.label} />
    </View>
  );
};

export default React.memo(SoundEffectView);

const styles = StyleSheet.create({
  container: {
    height: 208,
  } as ViewStyle,
  label: {
    fontSize: 20,
    marginLeft: 8,
  } as TextStyle,
});
